window.openPrivacyRequestModal = function(btn, isTeaserForm = false) {
    document.getElementById('privacy-request-modal-overlay').classList.add('active');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
}

$('.trigger-privacy-request-form').on('click', function () {
    openPrivacyRequestModal();
})

function doClosePrivacyRequestModal() {
    document.getElementById('privacy-request-modal-overlay').classList.remove('active');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
}

window.closePrivacyRequestModal = function(event) {
    // If clicking overlay background (not the modal box itself), close
    if (event && event.target !== document.getElementById('privacy-request-modal-overlay')) return;
    doClosePrivacyRequestModal();
}

// Also allow ESC key to close
document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
        doClosePrivacyRequestModal();
    }
});
